module.exports = __webpack_public_path__ + "media/images/emblems/Ennetburgen-coat_of_arms-4d4ef2d6492b252f28a6e0a455f120f4.svg";